import { useQuery } from '@tanstack/react-query'

import { listAdvertiserBrandSuggestionsService } from '../services/advertiser-brand'
import {
  advertiserBrandKey,
  advertiserBrandSuggestionsQueryKey
} from './advertiserBrandQueryKeys'

/**
 * Produtos do catálogo ainda sem vínculo, cada um com a marca sugerida. A
 * sugestão nunca grava — a confirmação humana passa por
 * `addAdvertiserBrandProducts` com `source='system_suggestion'`.
 */
export const useAdvertiserBrandSuggestions = ({
  enabled = true
}: { enabled?: boolean } = {}) => {
  const { isPending, isFetching, data, error } = useQuery({
    queryKey: advertiserBrandKey(advertiserBrandSuggestionsQueryKey),
    enabled,
    staleTime: 5 * 60 * 1000,
    queryFn: async () => {
      const response = await listAdvertiserBrandSuggestionsService()

      return response.data
    }
  })

  return { isPending, isFetching, data, error }
}
